import React, { Component } from 'react';
import {connect} from "react-redux";

import * as ActionTypes from "../../actions";

import ProductPlaceholder from "../../assets/product-placeholder.png";

const mapStateToProps = (state) => {
    return {
        facts: state.facts,
        products: state.products
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        fetchProduct: (id) => dispatch(ActionTypes.fetchProduct(id))
    };
};

class ProductImage extends Component {

    componentDidMount() {
        const {id, disableRefetch} = this.props;

        if ( ! disableRefetch) {
            this.props.fetchProduct(id);
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {id} = this.props;

        if (prevProps.id && prevProps.id !== id) { // ID has changed ...
            this.props.fetchProduct(id);
        }
    }

    showvalueReducer = showvalue => (accumulator, currentValue) => {
        if (currentValue.showvalues.includes(showvalue)) {
            accumulator = currentValue;
        }
        return accumulator;
    };

    blockValueByComparingAttributeValuesReducer = (values, showvalueToGet, showvalueToCompare, value) => (accumulator, currentValue) => {
        const showvalueToGetValue = currentValue.values?.reduce(this.showvalueReducer(showvalueToGet));
        const showvalueToCompareValue = currentValue.values?.reduce(this.showvalueReducer(showvalueToCompare));

        if (showvalueToCompareValue.value[0].externalids[0].externalId === value) {
            accumulator = showvalueToGetValue;
        }

        return accumulator;
    };

    getValue(node, showvalue) {
        return node?.values?.reduce(this.showvalueReducer(showvalue), null);
    }

    getBlockValueByComparingAttributeValues(block, showvalueToGet, showvalueToCompare, value) {
        return block?.value?.reduce(this.blockValueByComparingAttributeValuesReducer(block.value, showvalueToGet, showvalueToCompare, value), null);
    }

    getPublicImageUrl(asset) {
        if (asset && asset.valuetype === 'ASSET') {
            const token = localStorage.getItem('xom_access_token');
            const href = asset?.value[0]?._links[2]?.href;

            return href?.replace('{?mimeType,width,height}', '?access_token=' + token);
        }

        return ProductPlaceholder;
    }

    render() {
        const {id, products} = this.props;
        const product = products[id] ? products[id] : false;

        const image = this.getValue(product, 'pk_bild_erdstueck');

        return product && (
            <img alt="" src={this.getPublicImageUrl(image)} />
        );

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductImage);
